<section id="enquiry" class="section section--enquiry" aria-labelledby="enquiry-title" tabindex="-1">
  <div class="wrap">
    <div class="readable section-intro">
      <p class="eyebrow">Qualified enquiry</p>
      <h2 class="title" id="enquiry-title">Tell Me About the Assessment You Need</h2>
      <p>Describe who will use the assessment, where it should appear and what you want participants to do after completion.</p>
    </div>
    <div class="enquiry-layout">
      <wil-qualified-enquiry-form></wil-qualified-enquiry-form>
      <aside class="next-steps" aria-labelledby="next-steps-title">
        <p class="panel-label">What happens next</p>
        <h3 id="next-steps-title">A practical review, then a clear next step</h3>
        <ol>
          <li><span>1</span>You send the project context.</li>
          <li><span>2</span>I review the website and requirements.</li>
          <li><span>3</span>We clarify any open questions.</li>
          <li><span>4</span>You receive a proposed scope and next step.</li>
        </ol>
      </aside>
    </div>
  </div>
</section>
